import React from "react";
import MainLayout from "../../layouts/MainPage";
import UseGetData from "../../hooks/useFetchData";
import {
  GetRole,
  GetSuperAdmin,
  GetUserStandard,
} from "../../utils/RolesandAccess";
import { NavLink } from "react-router-dom";
import { useStandard } from "../../context/StandardContext";
import Viewmore from "./ViewMore";
import { MainStandardLoader } from "../../components/Loader";


function Standard() {
  const { updateName, updateId } = useStandard();
  const { data, getData, isLoading } = UseGetData({ url: "/Standards/" });

  function standardName(value) {
    updateName(value.name);
    updateId(value.id);
  }

  return (
    <MainLayout>
      <div className="w-[98%]  h-full grid md:grid-cols-3 lg:grid-cols-5 xl:grid-cols-6 gap-6  py-4 mx-auto overflow-y-scroll">
        {GetRole() ? (
          <>
            {isLoading == true ? (
              <>
                {[...Array(18)].map((_, index) => {
                  return <MainStandardLoader key={index} />;
                })}
              </>
            ) : (
              <>
                {data &&
                  data.map((value, idx) => {
                    return (
                      <div
                        className="flex"
                        key={idx}
                        style={{
                          opacity:
                            GetSuperAdmin() ||
                            (value?.isActive && value?.keyActivated)
                              ? 1
                              : 0.5,
                        }}
                      >
                        <NavLink
                          style={{
                            pointerEvents:
                              GetSuperAdmin() ||
                              (value?.isActive && value?.keyActivated)
                                ? "auto"
                                : "none",
                          }}
                          className="w-full"
                          to={`/standard/${value.id}/dashboard`}
                          onClick={() => {
                            standardName(value);
                          }}
                        >
                          <div className=" h-48 md:h-36 w-[100%] border flex flex-col items-center justify-center border-borderdark hover:border-0 rounded-xl py-2 m-auto hover:shadow-box">
                            {value?.image_path && (
                              <div className=" w-11/12 overflow-hidden h-[calc(128px-5px)] flex justify-center items-center">
                                <div className=" w-[95%] h-full ">
                                  <img
                                    src={value?.image_path}
                                    alt={value?.name}
                                    className={` object-center mx-auto`}
                                    // width="100%"
                                    style={{
                                      height: "calc(128px - 28px)",
                                      width: "auto",
                                    }}
                                  />
                                </div>
                              </div>
                            )}
                            <p className="my-1 text-center text-sm  md:text-[8px] 2xl:text-xs w-10/12 m-auto">
                              {value?.name || "no title"}
                            </p>
                          </div>
                        </NavLink>
                        {GetSuperAdmin() && (
                          <Viewmore fetcher={getData} data={value} />
                        )}
                      </div>
                    );
                  })}
              </>
            )}
          </>
        ) : (
          <>
            {isLoading == true ? (
              <>
                {[...Array(12)].map((_, index) => {
                  return <MainStandardLoader key={index} />;
                })}
              </>
            ) : (
              <>
                {data &&
                  data
                    .filter((item) => GetUserStandard().includes(item?.id))
                    .map((value, idx) => {
                      return (
                        <div
                          className="flex"
                          key={idx}
                          style={{
                            pointerEvents:
                              GetSuperAdmin() ||
                              (value?.isActive && value?.keyActivated)
                                ? "auto"
                                : "none",
                            opacity:
                              GetSuperAdmin() ||
                              (value?.isActive && value?.keyActivated)
                                ? 1
                                : 0.5,
                          }}
                        >
                          <NavLink
                            className="w-full"
                            to={`/standard/${value.id}/dashboard`}
                            onClick={() => {
                              standardName(value);
                            }}
                          >
                            <div className=" h-48 md:h-36 w-[100%] border flex flex-col items-center justify-center border-borderdark hover:border-0 rounded-xl py-2 m-auto hover:shadow-box">
                              {value?.image_path && (
                                <div className=" w-11/12 overflow-hidden h-[calc(128px-5px)] flex justify-center items-center">
                                  <div className=" w-[95%] h-full ">
                                    <img
                                      src={value?.image_path}
                                      alt={value?.name}
                                      className={` object-center mx-auto`}
                                      // width="100%"
                                      style={{
                                        height: "calc(128px - 28px)",
                                        width: "auto",
                                      }}
                                    />
                                  </div>
                                </div>
                              )}
                              <p className="my-1 text-center text-sm  md:text-[8px] 2xl:text-xs w-10/12 m-auto">
                                {value?.name || "no title"}
                              </p>
                            </div>
                          </NavLink>
                        </div>
                      );
                    })}
              </>
            )}
          </>
        )}
      </div>
    </MainLayout>
  );
}

export default Standard;
